"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DefaultDictionariesCacheService {
    constructor() {
        this._definitions = new Map();
        this._dictsItemsEntries = new Map();
    }
    getDefinition(id) {
        const definition = this._definitions.get(id);
        return definition;
    }
    setDefinition(definition) {
        this._definitions.set(definition.id, definition);
    }
    setItems(dictionaryHash, items) {
        let itemsEntry = this._dictsItemsEntries.get(dictionaryHash);
        if (itemsEntry === undefined) {
            itemsEntry = {
                items: new Map(),
            };
            this._dictsItemsEntries.set(dictionaryHash, itemsEntry);
        }
        items.forEach((item) => itemsEntry.items.set(item.id, item));
    }
    getItems(dictionaryHash, ids) {
        const itemsEntry = this._dictsItemsEntries.get(dictionaryHash);
        if (itemsEntry !== undefined) {
            const cachedItems = itemsEntry.items;
            const filteredItems = [];
            for (const id of ids) {
                const x = cachedItems.get(id);
                if (x !== undefined) {
                    filteredItems.push(x);
                }
            }
            return filteredItems;
        }
        else {
            return [];
        }
    }
    invalidateMetadata(dictionaryId) {
        if (dictionaryId !== undefined) {
            this._definitions.delete(dictionaryId);
        }
        else {
            this._definitions.clear();
        }
    }
    invalidateData(dictionaryHash) {
        if (dictionaryHash !== undefined) {
            this._dictsItemsEntries.delete(dictionaryHash);
        }
        else {
            this._dictsItemsEntries.clear();
        }
    }
}
exports.DefaultDictionariesCacheService = DefaultDictionariesCacheService;
//# sourceMappingURL=DefaultDictionariesCacheService.js.map